//@flow
import { 
    SET_PLAN_UPGRADE, 
    UNSET_PLAN_UPGRADE, 
    GET_UPGRADE_PLANS_DONE, 
    GET_MP_UPGRADE_PLANS_DONE,
    GET_BILL_AMOUNT_DONE,
    PLAN_UPGRADE_INIT,
    PLAN_UPGRADE_DONE,
    PLAN_UPGRADE_FAILED,
    STRIPE_CARD_DETAILS_INIT,
    STRIPE_CARD_DETAILS_DONE,
    STRIPE_CARD_DETAILS_FAILED,
    PAYMENT_INIT, 
    PAYMENT_DONE, 
    PAYMENT_FAILED,
    RESET_PAYMENT_ERROR,
    RESET_CARD_CHANGE_ERROR,
    STRIPE_SCA_REQUIRED,
    CLEAR_STRIPE_SCA,
} from '../actions'
import type { Pricing } from '../components/Account/UpgradePlans';
import { getIntegersParsedObject } from 'h-commons';

type Plan = {
    title: string,
    pricing: Pricing
}

type State = {
    plan: null | Plan
}

type Action = {
    type: string,
    payload: ?Object
}

const initState = {
    plan: null,
    availablePlans: {},
    current: {},
    annualPlansIds: null,
    monthlyPlansIds: null,
    activeUsers: 0,
    STRIPE_PUBLISH_KEY: null,
    stripeId: null,
    chargebeeId: null,
    bill: null,
    planUpgrading: false,
    upgradeAblePlans: [],
    paymentFailureError: '',
    cardChangeError: '',
    stripePaymentIntentId: '',
    stripePaymentIntentSecretKey: '',
    stripePaymentMethodId: '',
};

function accountUpgrade(state: State =  initState, action: Action) {
    switch (action.type) {
        case SET_PLAN_UPGRADE: 
            return { ...state, plan: action.payload };
        case UNSET_PLAN_UPGRADE: 
            return { ...state, plan: null };
        case GET_MP_UPGRADE_PLANS_DONE:
            return {...state, upgradeAblePlans: action.payload};
        case GET_UPGRADE_PLANS_DONE:
            return { ...state, ...getIntegersParsedObject(action.payload), paymentFailureError:"" };
        case GET_BILL_AMOUNT_DONE: {
            return { ...state, bill: getIntegersParsedObject(action.payload) };
        }
        case PAYMENT_INIT:
        case PLAN_UPGRADE_INIT:
        case STRIPE_CARD_DETAILS_INIT:
            return { ...state, planUpgrading: true, paymentFailureError: '' };
        case PLAN_UPGRADE_DONE:
        case PLAN_UPGRADE_FAILED:
        case PAYMENT_DONE:
            return { ...state, planUpgrading: false};
        case STRIPE_CARD_DETAILS_DONE:
            return { ...state, planUpgrading: false, cardChangeError: '' };
        case STRIPE_CARD_DETAILS_FAILED:
            return { ...state, planUpgrading: false, cardChangeError: action.payload };
        case PAYMENT_FAILED:
            return { ...state, planUpgrading: false, paymentFailureError: action.payload };
        case RESET_PAYMENT_ERROR:
            return { ...state, paymentFailureError: ''};
        case RESET_CARD_CHANGE_ERROR: 
            return { ...state, cardChangeError: ''};
        case CLEAR_STRIPE_SCA:
            return {...state, stripePaymentIntentSecretKey: "", stripePaymentIntentId: "",stripePaymentMethodId: ""}
        case STRIPE_SCA_REQUIRED:
            return {...state, ...action.payload}   
        default:
            return state;
    }
}
export default accountUpgrade;